
import { useContext, useEffect, useState } from 'react';
import './navComponent.css';
import LanguageSelector from '../languageSelector/LanguageSelector';
import { LangContext } from '../../context/langContext/LangContext';
import { langData } from '../../langData';
import { CLIENT_URL, CURRENT_URL } from '../../config/runtimeConfig';

function NavComponent() {
    const [offset, setOffset] = useState(0);
    const [navActive, setNavActive] = useState(false);
    const [languageDisplay, setLanguageDisplay] = useState(true)

    useEffect(() => {
        const onScroll = () => setOffset(window.scrollY);

        // clean up code
        window.removeEventListener('scroll', onScroll);
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, [])

    useEffect(() => {
        (offset > 75) ? setNavActive(true) : setNavActive(false);
    }, [offset])

    /************* Multi Language **************/
    const { lang } = useContext(LangContext)

    return (
        <>
            <div className="top-nav">
                <div className="wrapper">
                    <div className="logo logo-wrap">
                        <a href="#">
                            <img src={`${CURRENT_URL}/nwexpress.png`} alt="NWExpress" />
                        </a>
                    </div>
                    <LanguageSelector languageDisplay={languageDisplay} />
                </div>
            </div>
            <div className={navActive ? 'nav active' : 'nav'}>
                <div className="wrapper">
                    <div className="logo">
                        <a href="#">
                            <img src={`${CURRENT_URL}/nwexpress_white.png`} alt="NWExpress" />
                        </a>
                    </div>
                    <input type="radio" name="slide" id="menu-btn" />
                    <input type="radio" name="slide" id="cancel-btn" />
                    <ul className="nav-links">
                        <div className="logo logo-wrap">
                            <a href="#">
                                <img src={`${CURRENT_URL}/nwexpress.png`} alt="NWExpress" />
                            </a>
                        </div>
                        <label htmlFor="cancel-btn" className="btn cancel-btn" onClick={() => setLanguageDisplay(true)}>
                            <i className="fas fa-times"></i>
                        </label>
                        <li><a href="#accueil">{langData[lang]["nav"]["welcome"]}</a></li>
                        <li><a href="#propos">{langData[lang]["nav"]["about"]}</a></li>
                        <li><a href="#">{langData[lang]["nav"]["news"]}</a></li>
                        <li><a href="#">{langData[lang]["nav"]["agencies"]}</a></li>
                        <li><a href="#faq">{langData[lang]["nav"]["faq"]}</a></li>
                        <li><a href="#footer">{langData[lang]["nav"]["contact"]}</a></li>
                        <div className="buttons">
                            <a href={`${CLIENT_URL}`} target="_blank">{langData[lang]["buttons"]["suivre_votre_colis"]}</a>
                            <a href={`${CLIENT_URL}`} target="_blank">{langData[lang]["buttons"]["se_connecter"]}</a>
                        </div>
                    </ul>
                    <label htmlFor="menu-btn" className="btn menu-btn" onClick={() => setLanguageDisplay(false)}>
                        <i className="fas fa-bars"></i>
                    </label>
                </div>
            </div>

        </>
    )
}

export default NavComponent
